export default __webpack_public_path__ + "static/media/1.65e28850.png";